module.exports = __webpack_public_path__ + "static/media/tk.b75bd467.svg";